import { defineMessages } from "react-intl";

export const messages = defineMessages({
  appRemoved: {
    id: "uIPD1i",
    defaultMessage: "App successfully removed",
    description: "app has been removed",
  },
});
